import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.customColor.themePrimary,
    fontSize: '14px',
    padding: '8px 10px',
    maxHeight: 40,
    '&:hover': {
      backgroundColor: theme.palette.customColor.themePrimaryHover
    },
    '&.Mui-disabled': {
      background: theme.palette.customColor.themeDisablePrimaryBackground,
      color: theme.palette.customColor.themeDisablePrimaryColor
    }
  },
  text: {
    color: theme.palette.customColor.white
  }
}));

/**
 * @author odin, nick
 * @component PrimaryButton
 * @description 主要按鈕組件，支持 ref 轉發
 */
export const PrimaryButton = React.forwardRef(
  ({ children, className, classNameProps = '', ...props }, ref) => {
    const classes = useStyles();
    
    return (
      <Button
        ref={ref}  // 轉發 ref 給 Material-UI 的 Button
        className={`${classes.root} ${classes.text} ${className} ${classNameProps}`}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

PrimaryButton.displayName = 'PrimaryButton';

PrimaryButton.propTypes = {
  children: PropTypes.node,
  classNameProps: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  type: PropTypes.string
};

export default PrimaryButton;
